import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import PrepareDataTable from "./PrepareDataTable";
import {
  GeneralParametersListContainer,
  MainTitle,
} from "./GeneralParametersList.styled";
import "./GeneralParametersList.scss";
import AddEditGeneralParameter from "../AddEditGeneralParameter";

/**
 * GeneralParametersList List,
 * Path - /administration/generalParameters
 * @see See [GeneralParametersList Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3783884801/Administration+-+General+parameters)
 * @component
 */
const GeneralParametersList = (props) => {
  const { t, columnList, countries } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);
  const [isAddParameterPopupVisible, setAddParameterPopupVisible] =
    useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  const createNewParameter = () => {
    setAddParameterPopupVisible(true);
  };
  const closeParameterCreationPopup = () => {
    setAddParameterPopupVisible(false);
  };

  return (
    <GeneralParametersListContainer className="general-parameters-list">
      <MainTitle>{t("ADMINISTRATION_GENERAL_PARAMETERS_TITLE")}</MainTitle>
      <PrepareDataTable
        isRefreshList={isRefreshList}
        updateRefeshStatus={updateRefeshStatus}
        columnList={columnList}
        createNewParameter={createNewParameter}
        countries={countries}
      />
      {isAddParameterPopupVisible && (
        <AddEditGeneralParameter
          onClose={closeParameterCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
        />
      )}
    </GeneralParametersListContainer>
  );
};

GeneralParametersList.propTypes = {
  t: PropTypes.func.isRequired,
  columnList: PropTypes.arrayOf(PropTypes.string),
  countries: PropTypes.arrayOf(PropTypes.object),
};

GeneralParametersList.defaultProps = {
  columnList: [],
  countries: [],
};

export default withTranslation()(GeneralParametersList);
